var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.HasPermission(_vm.PermissionList.Production_Finance)
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Sales Price",
                        "label-for": "Operation-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "Operation-name", type: "number" },
                        model: {
                          value: _vm.data.invoiceAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "invoiceAmount", $$v)
                          },
                          expression: "data.invoiceAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Price of BOM",
                        "label-for": "Operation-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "Operation-name",
                          type: "number",
                          placeholder: "Please enter price of BOM",
                        },
                        model: {
                          value: _vm.data.plannedCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "plannedCost", $$v)
                          },
                          expression: "data.plannedCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Labour Cost",
                        "label-for": "labour-cost",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "labour-cost", type: "number" },
                        model: {
                          value: _vm.data.labourCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "labourCost", $$v)
                          },
                          expression: "data.labourCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Comment",
                        "label-for": "labour-cost-details",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "labour-cost-details",
                          placeholder: "Add Detailed Cost",
                          type: "text",
                        },
                        model: {
                          value: _vm.data.labourCostDetails,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "labourCostDetails", $$v)
                          },
                          expression: "data.labourCostDetails",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Transport/Logistics Cost",
                        "label-for": "transport-cost",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "transport-cost", type: "number" },
                        model: {
                          value: _vm.data.transportCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "transportCost", $$v)
                          },
                          expression: "data.transportCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Comment",
                        "label-for": "transport-cost-details",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "transport-cost-details",
                          placeholder: "Add Detailed Cost",
                          type: "text",
                        },
                        model: {
                          value: _vm.data.transportCostDetails,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "transportCostDetails", $$v)
                          },
                          expression: "data.transportCostDetails",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Any Other Additional Operating Cost",
                        "label-for": "Operation-name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "Operation-name", type: "number" },
                        model: {
                          value: _vm.data.additionalCost,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "additionalCost", $$v)
                          },
                          expression: "data.additionalCost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Comment",
                        "label-for": "Operation-name-details",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "Operation-name-details",
                          placeholder: "Add Detailed Cost",
                          type: "text",
                        },
                        model: {
                          value: _vm.data.additionalCostDetails,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "additionalCostDetails", $$v)
                          },
                          expression: "data.additionalCostDetails",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }